export const columns = [
  {
    title: "Nombre",
    dataIndex: "nombre",
    width: "25%",
    render: (text, record) => {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontWeight: "bold" }}>{text}</span>
          <img
            src={record.imagen}
            alt={text}
            style={{ width: "50px", height: "50px", borderRadius: "8px" }}
          />
        </div>
      );
    }
  },
  {
    title: "Descripción",
    dataIndex: "descripcion",
    width: "35%",
  },
  {
    title: "Consumible",
    dataIndex: "esConsumible",
    width: "15%",
  },
  {
    title: "Gacha",
    dataIndex: "esGacha",
    width: "25%",
  },
];

export const formatData = (data) => {
  return {
    idObjeto: data.id,
    obje_nombre: data.nombre,
    obje_descripcion: data.descripcion,
    obje_imagen: data.imagen,
    obje_consumible: data.consumible,
    obje_tier: data.tier,
    obje_gacha: data.gacha,
  };
};

export const camposFormulario = {
  title: "Objetos",
  campos: [
    {
      name: "idObjeto",
      label: "id",
      type: "number",
      hidden: true,
    },
    {
      name: "obje_nombre",
      label: "Nombre del Objeto",
      type: "text",
      rules: [
        {
          required: true,
          message: "El nombre del objeto es requerido",
        },
        {
          max: 45,
          message: "El nombre no puede tener más de 45 caracteres",
        },
        {
          min: 1,
          message: "El nombre debe tener al menos 1 caracter",
        },
      ],
    },
    {
      name: "obje_descripcion",
      label: "Descripción del Objeto",
      type: "text",
      rules: [
        {
          required: true,
          message: "La descripción del objeto es requerida",
        },
        {
          max: 100,
          message: "La descripción no puede tener más de 100 caracteres",
        },
        {
          min: 1,
          message: "La descripción debe tener al menos 1 caracter",
        },
      ],
    },
    {
      name: "obje_imagen",
      label: "Imagen",
      type: "text",
      rules: [
        {
          required: true,
          message: "La URL de la imagen es requerida",
        },
        {
          max: 255,
          message: "La URL no puede tener más de 255 caracteres",
        },
        {
          min: 1,
          message: "La URL debe tener al menos 1 caracter",
        },
      ],
    },
    {
      name: "obje_tier",
      label: "Tier del objeto",
      type: "number",
      rules: [
        {
          required: true,
          message: "El tier es requerido",
        },
        {
          type: "number",
          min: 1,
          max: 4,
          message: "El tier debe ser un número entre 1 y 4",
        },
      ],
    },
    {
      name: "obje_consumible",
      label: "Consumible",
      type: "checkbox",
      valuePropName: "checked",
      rules: [],
    },
    {
      name: "obje_gacha",
      label: "Es de Gacha",
      type: "checkbox",
      valuePropName: "checked",
      rules: [],
    },

  ],
};
export const camposFilter = {
  title: "Objetos",
  campos: [
    {
      name: "obje_nombre",
      type: "text",
      placeholder: "Nombre del Objeto",
      rules: [
        {
          max: 45,
          message: "Máximo 45 caracteres",
        },
      ],
    },
  ],
};
